import { cn } from "../../lib/utils";

/** Baseline-aligned disclosure chevron — shared by woorden + admin
 *  surfaces so the caret reads as a UI mark rather than a unicode glyph.
 *  `open` rotates 90deg to point down when expanded. */
export function Chevron({
  open,
  className,
}: {
  open: boolean;
  className?: string;
}) {
  return (
    <svg
      viewBox="0 0 12 12"
      width="10"
      height="10"
      aria-hidden
      className={cn(
        "text-[var(--ink-faint)] transition-transform duration-200",
        open ? "rotate-90" : "rotate-0",
        className,
      )}
    >
      <path
        d="M4 2.5 L8 6 L4 9.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
